<div>
    <form nz-form #moduleMasterPage="ngForm">
        <!-- <div nz-row nzGutter="5" *ngIf="ShowLinkOrNot">
            <div nz-col nzSpan="24">
                <a style="float: right;" (click)="openWorkLogsDrawer()">Work Logs</a>
            </div>
        </div> -->

        <div nz-row class="my-box" nzGutter="5">
            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Project</nz-form-label>

                    <nz-form-control>
                        <nz-select name="projectName" nzShowSearch nzAllowClear nzPlaceHolder="Select a Project"
                            [(ngModel)]="data.PROJECT_ID">
                            <nz-option *ngFor="let project of projectList" [nzValue]="project.ID"
                                [nzLabel]="project.NAME"></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>

        <div nz-row class="my-box" nzGutter="5">
            <div nz-col nzSpan="16">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Module Name</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Module Name is Required">
                        <input nz-input name="moduleName" type="text" placeHolder="Enter a Module Name"
                            [(ngModel)]="data.NAME" required />
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Status</nz-form-label>

                    <nz-form-control>
                        <nz-select name="status" nzShowSearch nzAllowClear nzPlaceHolder="Select a Module Status"
                            [(ngModel)]="data.STATUS">
                            <nz-option nzLabel="Pending" nzValue="P"></nz-option>
                            <nz-option nzLabel="Started" nzValue="S"></nz-option>
                            <nz-option nzLabel="Completed" nzValue="C"></nz-option>
                            <nz-option nzLabel="On Hold" nzValue="OH"></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-label nzNoColon>Description</nz-form-label>

                    <nz-form-control>
                        <textarea nz-input [nzAutosize]="{ minRows: 3, maxRows: 6 }" name="moduleDescription"
                            placeHolder="Enter a Module Description" [(ngModel)]="data.DESCRIPTION"></textarea>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzNoColon>Start Date</nz-form-label>

                    <nz-form-control>
                        <nz-date-picker style="width: 100%;" nzFormat="dd/MM/yyyy" name="startDate"
                            (nzOnOpenChange)="handleStartOpenChange($event)" [(ngModel)]="data.START_DATE">
                        </nz-date-picker>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzNoColon>End Date</nz-form-label>

                    <nz-form-control>
                        <nz-date-picker #endDatePicker style="width: 100%;" nzFormat="dd/MM/yyyy" name="endDate"
                            [(ngModel)]="data.END_DATE"></nz-date-picker>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzNoColon>Estimated Mandays</nz-form-label>

                    <nz-form-control>
                        <input nz-input name="estimatedMandays" type="number" min="1"
                            oninput="this.value = Math.abs(this.value)" placeHolder="Enter Mandays"
                            [(ngModel)]="data.ESTIMATED_MANDAYS" />
                    </nz-form-control>
                </nz-form-item>
            </div>

            <!-- <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Estimated Hours</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Estimated Hours is Required">
                        <input nz-input name="estimatedHours" type="number" min="0" oninput="this.value = Math.abs(this.value)" placeHolder="Enter Hours" [(ngModel)]="data.ESTIMATED_HOURS" required/>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Estimated Minutes</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Estimated Minutes is Required">
                        <input nz-input name="estimatedMinutes" type="number" min="0" oninput="this.value = Math.abs(this.value)" onkeyup="if(this.value> 60){this.value= 60}" placeHolder="Enter Minutes" [(ngModel)]="data.ESTIMATED_MINUTES" required/>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="8">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Estimated Seconds</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Estimated Seconds is Required">
                        <input nz-input name="estimatedSeconds" type="number" min="0" oninput="this.value = Math.abs(this.value)" onkeyup="if(this.value> 60){this.value= 60}" placeHolder="Enter Seconds" [(ngModel)]="data.ESTIMATED_SECONDS" required/>
                    </nz-form-control>
                </nz-form-item>
            </div> -->

            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-label nzNoColon>Active</nz-form-label>

                    <nz-form-control>
                        <nz-switch name="isActive" [(ngModel)]="data.IS_ACTIVE"></nz-switch>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
    </form>
</div>

<div class="footer">
    <button type="button" nz-button class="ant-btn" style="margin-right: 8px;"
        (click)="close(moduleMasterPage)"><span>Cancel</span></button>
    <button type="button" class="ant-btn ant-btn-primary" nz-button [nzLoading]="isSpinning" *ngIf="data.ID"
        (click)="save(false)"><span>Update & close</span></button>
    <button type="button" class="ant-btn ant-btn-primary" *ngIf="!data.ID" nz-button nz-dropdown [nzDropdownMenu]="menu"
        (click)="save(false)"><span>Save & Close</span></button>
    <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu>
            <li nz-menu-item class="menuc" style="border-radius: 4px;background-color: #40a9ff;">
                <a (click)="save(true)">Save & New</a>
            </li>
        </ul>
    </nz-dropdown-menu>

    <!-- <button type="button" nz-button class="ant-btn" style="margin-right: 8px;" (click)="resetDrawer(moduleMasterPage)"><span>Reset</span></button> -->
</div>